import InspectionHistory from "./InspectionHistory";

export default InspectionHistory;
